import React from 'react'
import PropTypes from 'prop-types'

interface ContentTableItemsProps {
    nodes: React.ReactNode[]
    active?: boolean
    onClick?: React.MouseEventHandler<HTMLTableRowElement>
}

export const ContentTableItems: React.FC<ContentTableItemsProps> = ({
    nodes,
    active,
    onClick,
}) => {
    return (
        <tbody className="rounded-b-3xl">
            <tr
                onClick={onClick}
                className={`table-row border-b-2 h-14 rounded-b-3xl hover:${
                    onClick ? 'cursor-pointer' : 'none'
                }  hover: ${onClick ? '' : ''} ${active ? '' : ' '}`}
            >
                {nodes.map((node, index) => (
                    <td key={index}>{node}</td>
                ))}
            </tr>
        </tbody>
    )
}

ContentTableItems.propTypes = {
    nodes: PropTypes.array.isRequired,
    active: PropTypes.bool,
    onClick: PropTypes.func,
}
